import { withInstall, withNoopInstall } from '@lit-element/utils'

import Steps from './src/steps.vue'
import Step from './src/item.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtSteps: SFCWithInstall<typeof Steps> & {
  Step: typeof Step
} = withInstall(Steps, {
  Step,
})
export default LtSteps
export const LtStep: SFCWithInstall<typeof Step> = withNoopInstall(Step)

export * from './src/item'
export * from './src/steps'
